import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getPermissions } from '../../../redux/actions/UI';
var ContextualActionsWrapper = function ContextualActionsWrapper(_ref) {
  var children = _ref.children;
  var dispatch = useDispatch();
  useEffect(function () {
    dispatch(getPermissions());
  }, [dispatch]);
  return children;
};
export default ContextualActionsWrapper;